<template>
  <div class="error-page">
    <img src="@/assets/images/502.jpg" alt />
    <h1 class="content">{{ $t("errorPage.badGateway.content") }}</h1>
    <p class="note">{{ $t("errorPage.badGateway.note1") }}</p>
    <p class="note">{{ $t("errorPage.badGateway.note2") }}</p>
    <p class="note">
      {{ $t("errorPage.badGateway.hotline", { phone: hotline }) }}
    </p>
    <el-button type="text" class="mt-2" @click="goBackHome">{{
      $t("buttons.goBackHome")
    }}</el-button>
  </div>
</template>

<script>
import CONSTANTS from '@/config/constants'
export default {
  name: 'BadGateway',
  data() {
    return {
      window,
      hotline: CONSTANTS.HOTLINE
    }
  },
  methods: {
    goBackHome() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
